import { formatNightlyRate } from '@/shared/lib/format';
import { priceMarks } from './priceRangeModel';

const LABEL = { minimum: 'Min', reference: 'Ref', maximum: 'Max' } as const;

/** Leiste Min · Ref · Max (Board „Preisautomatik · Einstellungen“), nur Darstellung der Eingaben. */
export function PriceRangeBar(props: {
  minimum: string;
  reference: string;
  maximum: string;
  currency: string;
}) {
  const marks = priceMarks(props.minimum, props.reference, props.maximum);
  if (marks.length === 0) return null;
  const first = Math.min(...marks.map((mark) => mark.position));
  const last = Math.max(...marks.map((mark) => mark.position));
  return (
    <div aria-hidden className="relative mx-2.5 mt-6 h-12">
      <span className="bg-card-alt absolute inset-x-0 top-[14px] h-1.5 rounded-full" />
      <span
        className="from-mint to-forest absolute top-[14px] h-1.5 rounded-full bg-gradient-to-r"
        style={{ left: `${first}%`, right: `${100 - last}%` }}
      />
      {marks.map((mark) => (
        <span
          key={mark.key}
          className="absolute top-[10px] flex -translate-x-1/2 flex-col items-center gap-0.5"
          style={{ left: `${mark.position}%` }}
        >
          <span className="border-forest-deep bg-card size-3.5 rounded-full border-[3px]" />
          {/* Ref steht über der Leiste, Min und Max darunter – so überdecken sie sich nicht. */}
          <span
            className={
              mark.key === 'reference'
                ? 'absolute -top-6 whitespace-nowrap text-[11px] font-bold'
                : 'whitespace-nowrap text-[11px] font-bold'
            }
          >
            {LABEL[mark.key]} {formatNightlyRate(mark.value, props.currency)}
          </span>
        </span>
      ))}
    </div>
  );
}
